import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputEmailsComponent } from './components/input-emails/input-emails.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [InputEmailsComponent],
  exports: [InputEmailsComponent]
})
export class EmailsInputModule {}



// WEBPACK FOOTER //
// ./src/app/utils/emails-input/emails-input.module.ts